import apiClient from './client';
import { ApiResponse } from '../types/api.types';
import { AdjustConfig } from '../types/game.types';

export const adjustApi = {
  getAdjustConfig: async (gameId: string): Promise<ApiResponse<AdjustConfig>> => {
    return apiClient.get(`/api/v1/admin/games/${gameId}/adjust-config`);
  },

  updateAdjustConfig: async (gameId: string, adjustConfig: AdjustConfig): Promise<ApiResponse<AdjustConfig>> => {
    return apiClient.put(`/api/v1/admin/games/${gameId}/adjust-config`, { adjustConfig });
  },

  addProductEvent: async (gameId: string, productId: string, eventToken?: string): Promise<ApiResponse<any>> => {
    return apiClient.post(`/api/v1/admin/games/${gameId}/adjust-config/products`, {
      productId,
      eventToken,
    });
  },
};